<micro-select-combo #sel
              placeholder="TBB Carrier"
              routerBase="tbb/carriers"
              [mode]="mode"
              [(id)]="tbbCarrierId"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
